module.exports = __webpack_public_path__ + "797f23a7f0546c5a68d39ade8e6884b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/night_130.jpg
// module id = 1764
// module chunks = 5